import React from 'react';
import { Container, Typography } from '@mui/material';
import QRCode from 'qrcode.react';
import UPShowLogo from '../../assets/UPshow_logo_primary.svg';

export default function Landing () {
    return (
        <Container variant='landing'>
            <Container variant='qr-container'>
                <QRCode
                  id={process.env.REACT_APP_REMOTE_CONTROL}
                  value={process.env.REACT_APP_REMOTE_CONTROL}
                  size={380}
                  includeMargin
                  className='qr-code'
                />
                <Typography variant='landing-text'>Scan for remote control access</Typography>
            </Container>
            <img height='42px' src={UPShowLogo} alt='UPshow' />
        </Container>
    );
}
